import React from "react";
import SEO from "@/components/SEO";
import ServiceLocationTemplate from "@/components/ServiceLocationTemplate";

const GlenroyEmergencyDentistPage = () => (
  <ServiceLocationTemplate suburbName="Glenroy" suburbSlug="glenroy" variant="emergency-dentist" />
);

export default GlenroyEmergencyDentistPage;
